import { Form, Button, Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';
import { C } from '../general/colors';

function ProductTypes(props) {
    const { setIsLoading } = props;

    const [productTypes, setProductTypes] = useState([]);
    const [idEdit, setIdEdit] = useState('');
    const [productType, setProductType] = useState('');
    const [isVisible, setIsVisible] = useState(true);
    const [isCreation, setIsCreation] = useState(false);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');

    useEffect(() => {
        setMessageType('warning');
        setMessage(productType === '' ? 'Tipo de producto es obligatorio' : '');
    }, [productType]);

    const setEditData = (row) => { setIdEdit(row.id); setProductType(row.name); setIsVisible(row.is_visible); };

    useEffect(() => { if (isCreation) { setProductType(''); setIsVisible(true); setIdEdit(''); } }, [isCreation]);

    const getProductTypes = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('/product-types');
            setProductTypes(response.data);
            setIdEdit('');
        } catch (error) { console.log(error); }
        finally { setIsLoading(false); }
    };

    const saveProductType = async () => {
        setIsLoading(true);
        const data = { name: productType, is_visible: isVisible };
        try {
            if (isCreation) {
                await axiosInstance.post('/product-types', data);
                setIsCreation(false);
            } else {
                await axiosInstance.put(`/product-types/${idEdit}`, data);
                setIdEdit('');
            }
            getProductTypes();
        } catch (error) {
            setMessageType('danger');
            setMessage(error.response.data.message.indexOf('Duplicate') > 0
                ? 'Tipo de producto ya existe' : error.message);
        } finally { setIsLoading(false); }
    };

    const deleteProductType = async (id, confirmed) => {
        if (!confirmed) {
            setAlertModalShow(true);
            setAlertModalType('');
            setAlertModalMsg('¿Está seguro de eliminar el tipo de producto ' + id + '?');
            setAlertModalOnConfirm(() => () => { deleteProductType(id, true); });
            return;
        }
        setIsLoading(true);
        try {
            await axiosInstance.delete(`/product-types/${id}`);
            setAlertModalShow(true);
            setAlertModalMsg('Tipo de producto eliminado correctamente');
            setAlertModalOnClose(() => () => { setIdEdit(''); setIsCreation(false); });
            getProductTypes();
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            setAlertModalMsg(
                error.response.data.message.includes('foreign')
                    ? 'No se puede eliminar: está en uso por productos'
                    : error.response.data.message
            );
        } finally { setIsLoading(false); }
    };

    useEffect(() => { if (!productTypes.length) getProductTypes(); }, []);

    const isFormOpen = idEdit || isCreation;

    return (
        <>
            {!isFormOpen && (
                <div className="order-section">
                    <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                        <span><i className="fa fa-tags" /> Tipos de Producto</span>
                        <Button size="sm" variant="primary" onClick={() => setIsCreation(true)}>
                            <i className="fa fa-plus" /> Crear
                        </Button>
                    </div>
                    <table className="report-table mb-0" style={{ width: '100%', borderRadius: 0, border: 'none' }}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Tipo</th>
                                <th>Visible</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {productTypes.map(item => (
                                <tr key={item.id}>
                                    <td style={{ fontWeight: 700, color: 'var(--abi-primary)', fontSize: 12 }}>#{item.id}</td>
                                    <td style={{ fontWeight: 600 }}>{item.name}</td>
                                    <td>
                                        <span className="report-status-badge" style={
                                            item.is_visible
                                                ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
                                                : { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
                                        }>
                                            {item.is_visible ? 'Visible' : 'Oculto'}
                                        </span>
                                    </td>
                                    <td style={{ display: 'flex', gap: 6 }}>
                                        <button className="report-icon-btn" title="Editar" onClick={() => setEditData(item)}>
                                            <i className="fa fa-pencil" />
                                        </button>
                                        <button className="report-icon-btn" title="Eliminar"
                                            onClick={() => deleteProductType(item.id)}
                                            style={{ color: C.danger }}>
                                            <i className="fa fa-trash" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {isFormOpen && (
                <>
                    <div className="order-page-header">
                        <div className="order-page-title">
                            <i className="fa fa-tag" style={{ color: 'var(--abi-primary)' }} />
                            {idEdit ? `Editar tipo #${idEdit}: ${productType}` : 'Crear tipo de producto'}
                        </div>
                        {idEdit && (
                            <Button size="sm" variant="outline-danger" onClick={() => deleteProductType(idEdit)}>
                                <i className="fa fa-trash" /> Eliminar
                            </Button>
                        )}
                    </div>

                    <div className="order-section">
                        <div className="order-section-header"><i className="fa fa-tag" /> Datos del tipo</div>
                        <div className="order-section-body">
                            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                                <div style={{ flex: 1, minWidth: 200 }}>
                                    <Form.Label className="report-field-label">Nombre del tipo</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ej: Alimentación, Papelería…"
                                        value={productType}
                                        onChange={(e) => setProductType(e.target.value)}
                                    />
                                </div>
                                <div style={{ paddingBottom: 4 }}>
                                    <Form.Check
                                        type="switch" id="visible-switch"
                                        label="Visible en catálogo"
                                        checked={isVisible}
                                        onChange={(e) => setIsVisible(e.target.checked)}
                                    />
                                </div>
                            </div>
                            {message && (
                                <Alert variant={messageType} className="py-2 mt-3" style={{ fontSize: 13 }}>
                                    {message}
                                </Alert>
                            )}
                        </div>
                    </div>

                    <div className="order-form-footer">
                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                            <Button variant="outline-secondary" size="sm" onClick={() => { setIdEdit(''); setIsCreation(false); }}>
                                <i className="fa fa-arrow-left" /> Volver
                            </Button>
                            <Button variant="primary" size="sm" onClick={saveProductType} disabled={!!message}>
                                <i className="fa fa-save" /> Guardar
                            </Button>
                        </div>
                    </div>
                </>
            )}

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(ProductTypes);
